
import axios from 'axios';
import {localapiurl} from '../constant';
import axios2 from '../api/axios';
export const authservices = {
    login,
    register,
    logout,
    getroles  
}

async function login(objdata){
    let data = objdata;
    return axios({
        method: 'post',
        url: `${localapiurl}/login`,
        data: data
      }).then((response)=>{
           return response;
      }).catch((error)=>{
         
      });     
}


async function register(objdata){
    let data = objdata;   
    return axios({
        method: 'post',
        url: `${localapiurl}/register`,
        data: data,
      }).then((response)=>{
          console.log("response data");
          console.log(response);
          if(response.status == 200){
            //   console.log(response.data.token); 
              let tokendata = response.data.token;
              localStorage.setItem('token',tokendata);  
              
          }
            return response;
          
      }).catch((error)=>{
         console.log("error");
         console.log(error);
      });     
}


function logout(objdata){
    let data = objdata;
    return axios({
        method: 'post',
        url: `${localapiurl}/logout`,
        data: data
      }).then((response)=>{
           return response;
      }).catch((error)=>{
           console.log(error);
      });     
}

function getroles(){
    return axios2.get('/getroles').then((response)=>{
       return response;    
    }).catch((error)=>{
        console.log(error);   
    });
}